module.exports = __webpack_public_path__ + "img/done.8bcab1c0.svg";